"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerRecognitionForm = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const flora_react_1 = require("@grupoboticario/flora-react");
const react_1 = __importStar(require("react"));
const content_1 = require("../../../content/index.js");
const hooks_1 = require("../../../hooks/index.js");
const services_1 = require("../../../services/index.js");
const types_1 = require("../../../types/index.js");
const utils_1 = require("../../../utils/index.js");
const ErrorFeedback_1 = require("../ErrorFeedback/index.js");
const GenericSignupForm_1 = require("../GenericSignupForm/index.js");
const Component = ({ catalogName, originIdentifier, formId, onSkip, onSubmit, ErrorFeedbackProps, LoadingProps, }) => {
    const [createCustomerError, setCreateCustomerError] = (0, react_1.useState)(false);
    const [loadingSubmit, setLoadingSubmit] = (0, react_1.useState)(false);
    const { formContentData, isFormContentLoading, hasErrorOnFormContent, isFormContentFetching } = (0, hooks_1.useFormContent)(formId || types_1.FormContentPageId.EMBEDDED_FORM);
    const handleSubmit = (formData, e) => __awaiter(void 0, void 0, void 0, function* () {
        if (formContentData) {
            setCreateCustomerError(false);
            setLoadingSubmit(true);
            try {
                const { token } = yield (0, services_1.createCustomer)(formData, formContentData, {
                    identifier: originIdentifier,
                });
                (0, services_1.sendCreateCustomerEvent)(e === null || e === void 0 ? void 0 : e.target);
                (0, utils_1.setCustomerToken)(token);
                onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(token);
            }
            catch (error) {
                (0, services_1.sendCreateCustomerFailureEvent)(e === null || e === void 0 ? void 0 : e.target);
                setCreateCustomerError(true);
            }
            finally {
                setLoadingSubmit(false);
            }
        }
    });
    if (isFormContentLoading || isFormContentFetching) {
        return ((0, jsx_runtime_1.jsx)(flora_react_1.Flex, Object.assign({ "aria-busy": true, "aria-label": 'Carregando, por favor aguarde', style: Object.assign({ minHeight: 300, alignItems: 'center', justifyContent: 'center' }, LoadingProps === null || LoadingProps === void 0 ? void 0 : LoadingProps.css) }, { children: (LoadingProps === null || LoadingProps === void 0 ? void 0 : LoadingProps.children) || (0, jsx_runtime_1.jsx)(flora_react_1.Spinner, { size: 'lg' }) })));
    }
    if (hasErrorOnFormContent ||
        !formContentData ||
        !Object.keys(formContentData).length ||
        createCustomerError) {
        return ((0, jsx_runtime_1.jsx)(ErrorFeedback_1.ErrorFeedback, Object.assign({ title: content_1.content.error.title, description: content_1.content.error.description, retryButtonProps: {
                label: content_1.content.error.retryButton,
                onClick: ErrorFeedbackProps.onRetry,
            } }, (Boolean(ErrorFeedbackProps.onContinue) && {
            continueButtonProps: {
                label: content_1.content.error.continueWithoutIdentificationButton,
                onClick: ErrorFeedbackProps.onContinue,
            },
        }))));
    }
    return ((0, jsx_runtime_1.jsx)(GenericSignupForm_1.GenericSignupForm, { catalogName: catalogName, isLoading: loadingSubmit, contentData: formContentData, onSubmit: handleSubmit, onSkip: onSkip }));
};
/**
 * @component
 * @name CustomerRecognitionForm
 * @description Formulário para ser usado no fluxo de Reconhecimento de Cliente Final
 * para identificar o cliente.
 */
exports.CustomerRecognitionForm = react_1.default.memo(Component);
